export const FOCUS_PRIORITY = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type FocusPriority =
  (typeof FOCUS_PRIORITY)[keyof typeof FOCUS_PRIORITY];

export const FOCUS_PRIORITY_VALUES: FocusPriority[] =
  Object.values(FOCUS_PRIORITY);
